import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { signupSearchParams } from 'router/search/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { validateLeadStatus } from 'router/validateLeadStatus';

export const Route = createFileRoute('/_signup/offer/decline/')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  beforeLoad: ({ context, location, preload, cause }) =>
    beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validateLeadStatus,
      validation: {
        validate: ({ lead }) => !!lead?.offer?.offerId,
        redirectTarget: '/offer',
      },
    }),
});
